import React from 'react';

interface StepsWrapperProps {
    isActive: boolean;
    isDown: boolean;
    children: JSX.Element;
}

export function StepWrapper({ isActive, children, isDown }: StepsWrapperProps): JSX.Element {
    const classes = ['steps-desktop__step-wrapper', isActive && 'is-active', !isActive && isDown && 'is-down']
        .filter(Boolean)
        .join(' ');
    return <div className={classes}>{children}</div>;
}
